import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: "absolute",
    top: 4,
    right: 10,
  },
  list: {
    paddingTop: 0,
  },
  listItemTextPrimary: {
    fontSize: "1.4rem",
    // fontWeight: 700,
  },
}));

const TocDialog = ({ toc, open, onClose, onItemClick, ...props }) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      aria-label="table of contents"
      open={open}
      maxWidth="sm"
      fullWidth={true}
      {...props}
    >
      <DialogTitle id="simple-dialog-title">
        <Typography component="span" variant="h3">
          Table of Contents
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <List className={classes.list}>
          {toc.map((item, idx) => (
            <Fragment key={`${idx}:${item.label}`}>
              <ListItem
                // dense={true}
                button
                onClick={() => onItemClick(item)}
              >
                <ListItemText
                  classes={{ primary: classes.listItemTextPrimary }}
                  primary={item.label}
                />
              </ListItem>
              {idx !== toc.length - 1 && <Divider />}
            </Fragment>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TocDialog;
